// { etiquetaId: { perfil, castellers: [{ id }] } } from /all_user_etiquetes
// ({ userId: [etiquetaId, …] }): one request instead of one per etiqueta.
// Only the ids are kept; the lists match them against the attendance rows.
export const etiquetaUsersFromMapping = (etiquetes, mapping) => {
    const etiquetaUsers = Object.fromEntries((etiquetes || []).map(etiqueta =>
        [etiqueta.id, { perfil: etiqueta.nom, castellers: [] }]
    ));

    Object.entries(mapping || {}).forEach(([userId, etiquetaIds]) => {
        (etiquetaIds || []).forEach(etiquetaId => {
            etiquetaUsers[etiquetaId]?.castellers.push({ id: Number(userId) });
        });
    });

    return etiquetaUsers;
};
